var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 758,
    height: 106,
    viewBox: "0 0 758 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_6961)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 757,
    height: 106,
    transform: "translate(0.5)",
    fill: "#EFE9F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2006_6961)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 757,
    height: 106,
    transform: "translate(0.5)",
    fill: "#EFE9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1154 52.4385C74.6093 37.3291 54.9212 26.7168 35.0023 29.2061C29.7357 29.8643 24.4673 31.4638 20.2224 34.6158C14.6505 38.7534 11.3746 45.0924 7.94816 51.0421C0.692826 63.6365 -8.01626 75.3934 -18.0066 86.0797C-22.9377 91.3529 -28.3602 96.4804 -35.1053 99.2141C-48.6291 104.695 -64.8356 98.9097 -74.3254 88.2511C-80.2535 81.593 -84.3709 73.0581 -89.6116 65.8991C-93.3304 66.8306 -97.7586 67.9501 -102.518 69.1743C-115.672 72.5584 -126.344 75.4538 -126.344 75.4538C-126.344 75.4538 -117.742 55.8388 -105.109 59.1118C-101.072 60.1577 -96.9193 60.9522 -93.1365 61.5497C-95.9914 58.4144 -99.2616 55.7705 -103.29 53.9978C-111.232 50.5026 -120.587 51.3216 -128.988 53.8523C-137.809 56.5097 -146.229 61.1046 -152.2 68.0048C-162.837 80.2969 -164.158 97.5395 -164.984 113.504L-152.592 116.093C-148.862 110.922 -142.933 105.241 -135.671 107.122C-123.038 110.395 -109.269 111.21 -109.269 111.21C-109.269 111.21 -119.925 113.801 -133.08 117.185C-135.289 117.753 -137.426 118.307 -139.457 118.837L-1.87021 147.578C38.6801 137.928 68.6137 128.112 107.409 119.987C109.433 119.563 111.362 108.227 110.699 105.539C106.029 86.5939 99.6215 67.5479 87.1154 52.4385ZM49.1761 67.4924C36.0215 70.8764 25.3497 73.7719 25.3497 73.7719C25.3497 73.7719 33.9513 54.1568 46.5847 57.4298C59.2181 60.7027 72.9869 61.5173 72.9869 61.5173C72.9869 61.5173 62.3308 64.1084 49.1761 67.4924L49.1761 67.4924Z",
    fill: "#E7DEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.961 43.7702C858.846 30.1513 838.096 21.803 818.58 26.5003C813.42 27.7423 808.363 29.9199 804.496 33.5261C799.421 38.2598 796.873 44.9249 794.132 51.2199C788.328 64.5455 780.986 77.201 772.251 88.9358C767.939 94.7265 763.123 100.427 756.725 103.897C743.898 110.853 727.147 106.913 716.527 97.3805C709.892 91.4257 704.848 83.4038 698.841 76.8745C695.249 78.2154 690.974 79.8222 686.381 81.57C673.686 86.4013 663.404 90.47 663.404 90.47C663.404 90.47 669.763 70.0174 682.682 71.8596C686.811 72.4483 691.027 72.7744 694.852 72.9458C691.665 70.1488 688.12 67.8864 683.92 66.5745C675.637 63.9877 666.432 65.846 658.366 69.2986C649.896 72.9241 642.042 78.4302 636.879 85.9538C627.68 99.3565 628.292 116.639 629.253 132.596L641.857 133.785C644.987 128.23 650.244 121.923 657.67 122.982C670.59 124.824 684.364 124.096 684.364 124.096C684.364 124.096 674.064 127.861 661.369 132.692C659.237 133.504 657.175 134.293 655.217 135.045L795.151 148.248C834.371 134.132 863.022 121.036 900.668 108.631C902.632 107.984 903.283 96.503 902.325 93.9058C895.569 75.6009 887.075 57.3891 872.961 43.7702ZM836.939 62.9651C824.244 67.7964 813.962 71.8651 813.962 71.8651C813.962 71.8651 820.321 51.4125 833.24 53.2547C846.16 55.0969 859.934 54.3694 859.934 54.3694C859.934 54.3694 849.634 58.1338 836.939 62.9651L836.939 62.9651Z",
    fill: "#E7DEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.615 52.4385C377.109 37.3291 357.421 26.7168 337.502 29.2061C332.236 29.8643 326.967 31.4638 322.722 34.6158C317.15 38.7534 313.875 45.0924 310.448 51.0421C303.193 63.6366 294.484 75.3934 284.493 86.0797C279.562 91.3529 274.14 96.4804 267.395 99.2141C253.871 104.695 237.664 98.9097 228.175 88.2511C222.247 81.593 218.129 73.0581 212.888 65.8991C209.17 66.8306 204.741 67.9501 199.982 69.1743C186.828 72.5584 176.156 75.4539 176.156 75.4539C176.156 75.4539 184.758 55.8388 197.391 59.1118C201.428 60.1577 205.581 60.9522 209.363 61.5497C206.509 58.4144 203.238 55.7705 199.21 53.9978C191.268 50.5026 181.913 51.3216 173.512 53.8523C164.691 56.5097 156.271 61.1046 150.3 68.0048C139.663 80.2969 138.342 97.5395 137.516 113.504L149.908 116.093C153.638 110.922 159.567 105.241 166.829 107.122C179.462 110.395 193.231 111.21 193.231 111.21C193.231 111.21 182.575 113.801 169.42 117.185C167.211 117.753 165.074 118.307 163.043 118.837L300.63 147.578C341.18 137.928 371.114 128.112 409.909 119.987C411.933 119.563 413.862 108.227 413.199 105.539C408.529 86.5939 402.121 67.5479 389.615 52.4385ZM351.676 67.4924C338.521 70.8764 327.85 73.7719 327.85 73.7719C327.85 73.7719 336.451 54.1568 349.085 57.4298C361.718 60.7028 375.487 61.5173 375.487 61.5173C375.487 61.5173 364.831 64.1084 351.676 67.4924L351.676 67.4924Z",
    fill: "#E7DEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.461 43.7702C616.346 30.1513 595.596 21.803 576.08 26.5003C570.92 27.7423 565.863 29.9199 561.996 33.5261C556.921 38.2598 554.373 44.9249 551.632 51.2199C545.828 64.5455 538.486 77.201 529.751 88.9358C525.439 94.7265 520.623 100.427 514.225 103.897C501.398 110.853 484.647 106.913 474.027 97.3805C467.392 91.4257 462.348 83.4038 456.341 76.8745C452.749 78.2154 448.474 79.8222 443.881 81.57C431.186 86.4013 420.904 90.47 420.904 90.47C420.904 90.47 427.263 70.0174 440.182 71.8596C444.311 72.4483 448.527 72.7744 452.352 72.9458C449.165 70.1488 445.62 67.8864 441.42 66.5745C433.137 63.9877 423.932 65.846 415.866 69.2986C407.396 72.9241 399.542 78.4302 394.379 85.9538C385.18 99.3565 385.792 116.639 386.753 132.596L399.357 133.785C402.487 128.23 407.744 121.923 415.17 122.982C428.09 124.824 441.864 124.096 441.864 124.096C441.864 124.096 431.564 127.861 418.869 132.692C416.737 133.504 414.675 134.293 412.717 135.045L552.651 148.248C591.871 134.132 620.522 121.036 658.168 108.631C660.132 107.984 660.783 96.503 659.825 93.9058C653.069 75.6009 644.575 57.3891 630.461 43.7702ZM594.439 62.9651C581.744 67.7964 571.462 71.8651 571.462 71.8651C571.462 71.8651 577.821 51.4124 590.74 53.2547C603.66 55.0969 617.434 54.3694 617.434 54.3694C617.434 54.3694 607.134 58.1338 594.439 62.9651L594.439 62.9651Z",
    fill: "#E7DEEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.875 93.5612L124.829 68.9325L98.1412 58.0958L94.1875 95.5315L120.875 93.5612Z",
    fill: "#77474E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.7 129.96C145.408 131.073 143.073 132.078 140.703 132.97C135.964 134.757 131.071 136.106 126.052 137.006C121.146 137.889 116.11 138.337 111.073 138.337C104.269 138.337 97.5042 137.524 90.9619 135.914C88.4 135.288 85.8162 134.523 83.2762 133.631C83.0099 133.535 82.7394 133.439 82.4731 133.343C79.322 132.204 76.2232 130.869 73.2424 129.359C72.8408 129.159 72.4393 128.954 72.0378 128.737C71.5926 128.511 71.1518 128.272 70.7066 128.024C70.1392 127.715 69.5762 127.393 69.0132 127.067C67.1278 125.979 65.2729 124.805 63.5009 123.582L63.3831 123.504C63.2784 123.43 63.1736 123.361 63.0732 123.287C63.1387 122.943 63.1998 122.63 63.2565 122.351C63.4747 121.26 63.6188 120.659 63.6188 120.659L75.5686 96.056L78.8987 89.2006L80.5222 88.5349L92.7863 83.5109H122.761L132.219 87.4084C132.219 87.4084 132.267 87.5868 132.363 87.9305C133.306 91.3017 138.805 110.441 147.337 129.168C147.455 129.429 147.577 129.694 147.7 129.96Z",
    fill: "#51BDC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.67 74.7021C129.864 69.7745 137.363 54.3115 132.419 40.1646C127.475 26.0177 111.96 18.5441 97.766 23.4718C83.572 28.3994 76.0734 43.8624 81.0175 58.0093C85.9616 72.1562 101.476 79.6298 115.67 74.7021Z",
    fill: "#824E55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5679 88.3009L80.5211 88.5343L72.2239 127.853L72.152 128.196L72.0365 128.737C71.5899 128.51 71.1496 128.271 70.7062 128.025C70.1378 127.713 69.5757 127.393 69.0105 127.066C67.1275 125.98 65.2725 124.803 63.4988 123.583L63.3801 123.502C63.2771 123.431 63.1709 123.359 63.071 123.288C61.7157 122.345 60.3947 121.361 59.105 120.346C59.0956 120.34 59.0894 120.334 59.08 120.325C56.7785 118.476 54.5614 116.487 52.441 114.374C51.0732 113.01 49.7585 111.607 48.5 110.166L48.6905 109.369L48.7092 109.288L48.9466 108.273C51.0576 99.3873 58.1994 92.568 67.1962 90.85L79.1502 88.5686L80.5679 88.3009Z",
    fill: "#51BDC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.228 117.048C158.706 120.037 154.93 122.743 150.946 125.118C150.557 125.353 150.16 125.583 149.763 125.814C148.069 126.788 146.345 127.697 144.6 128.545C142.308 129.659 139.973 130.664 137.604 131.556L137.42 130.694L128.05 86.2857L129.263 86.5164L141.422 88.8392C150.418 90.5575 157.562 97.378 159.67 106.265L161.996 116.083L162.228 117.048Z",
    fill: "#51BDC4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.706 45.6616C138.906 48.3746 139.421 60.628 131.635 65.9473C130.106 66.9941 126.26 68.9234 126.982 67.5628C127.146 67.2525 127.303 66.9491 127.462 66.6497C133.74 54.6592 135.679 47.9888 129.791 36.7207C126.044 29.5456 111.067 27.0483 103.751 28.8232C100.667 29.5719 97.2103 31.9001 95.6022 35.3652C92.9448 41.078 98.2116 53.9532 98.6036 62.4538C98.706 64.7304 98.4633 66.694 97.6267 68.1221C97.1059 69.0123 96.3506 68.3717 95.5393 67.1747C93.8143 64.632 91.8276 59.5688 91.275 61.3864C89.6814 66.652 94.5461 71.2091 96.179 73.0515C96.514 73.4282 96.8472 73.7866 97.1734 74.125L97.1748 74.129C97.3623 74.3217 97.5541 74.5133 97.7374 74.6939L97.7388 74.6979C102.772 79.6572 107.056 80.5697 111.474 83.2139C113.208 84.2471 114.959 85.5415 116.786 87.4502C118.038 88.7569 119.094 90.1404 119.98 91.5508C124.449 98.613 124.77 106.328 124.86 108.425C125.042 112.793 125.354 120.298 120.647 126.23C114.738 133.68 106.327 131.842 104.611 137.565C104.588 137.632 104.57 137.698 104.551 137.765C104.492 137.993 104.446 138.216 104.415 138.434C101.064 138.391 97.6965 138.145 94.3835 137.697C93.9382 137.64 93.4914 137.578 93.0405 137.505C92.5455 137.437 92.0503 137.356 91.548 137.267C91.4195 136.953 91.2911 136.638 91.1653 136.318C88.9798 130.844 87.2117 124.609 86.4717 118.034C86.0024 113.835 85.5363 109.672 85.5889 105.485C85.624 102.755 85.8768 100.014 86.502 97.2404C86.9993 95.0133 87.7295 92.7653 88.7726 90.4869C91.0642 85.4858 93.7197 82.8091 92.8427 78.6729C91.5926 72.7688 85.0921 73.1187 79.9736 65.3098C76.476 59.9696 72.0106 52.0724 71.502 45.883C71.0203 40.0346 70.6054 34.9597 73.0551 28.9961C73.6458 27.5657 78.9734 17.1945 87.7857 12.7349C91.8478 10.6845 97.5488 14.8042 103.11 14.1862C109.502 13.4735 113.162 13.0641 117.359 14.4398C124.45 16.7592 128.257 22.5868 131.79 28.0023C134.556 32.2383 138.134 37.7165 138.706 45.6616Z",
    fill: "#2F2E41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.199 84.7806C136.199 84.7806 113.236 64.1592 124.299 62.556C135.362 60.9528 141.643 74.0752 141.643 74.0752L144.124 82.8837L137.355 85.5485L136.199 84.7806Z",
    fill: "#A0616A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.764 168.665C149.557 167.938 151.118 172.123 149.099 170.785C141.004 166.424 145.073 167.865 144.542 164.933L139.726 164.868L138.247 156.504L136.04 150.523L141.354 140.603C141.713 139.929 142.218 139.343 142.832 138.886C143.445 138.43 144.153 138.114 144.904 137.961L138.688 133.992L152.768 120.067L134.286 84.9799L135.482 83.595L143.464 74.3367L144.695 72.9084L176.859 119.397L171.18 134.351L165.032 150.918L164.986 154.354L163.569 167.802L164.708 175.08L163.377 181.844L157.096 170.895C151.497 174.834 158.139 163.234 151.367 164.304L152.764 168.665Z",
    fill: "#7DCDD3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2006_6961)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.613 70.1441C568.568 61.3783 562.203 56.8412 548.883 61.55C545.361 62.795 541.989 64.7022 539.572 67.5488C536.399 71.2855 532.919 74.4823 531.515 79.1745C519.272 80.5816 525.849 67.5489 521.516 70.554C518.967 74.994 516.057 79.4045 511.85 82.3283C503.416 88.1907 533.417 86.5302 525.165 80.4458C520.011 76.645 515.801 71.2557 511.04 67.0007C508.628 68.208 505.758 69.6528 502.676 71.2204C494.159 75.5536 487.273 79.1745 487.273 79.1745C487.273 79.1745 490.044 64.1056 499.272 64.5304C502.222 64.6661 505.21 64.608 507.912 64.4662C505.441 62.6858 502.763 61.3126 499.703 60.6645C493.67 59.3867 487.357 61.3521 481.978 64.3792C476.468 68.8371 474.506 72.0391 471.502 77.7775C466.152 88 468.016 100.319 470.015 111.667L478.968 111.646C480.705 107.456 480.638 102.582 485.942 102.826C495.171 103.251 504.787 101.778 504.787 101.778C504.787 101.778 497.863 105.183 489.346 109.516C487.916 110.244 486.533 110.95 485.219 111.624C485.219 111.624 553.128 111.396 584.619 111.396C616.111 111.396 571.992 111.396 605.992 111.396C607.317 110.798 605.29 105.767 604.401 103.976C598.136 91.3494 590.659 78.9099 579.613 70.1441ZM577.757 91.2208C569.24 95.554 562.355 99.1749 562.355 99.1749C562.355 99.1749 565.125 84.106 574.354 84.5308C583.583 84.9555 584.294 83.4831 584.294 83.4831C584.294 83.4831 586.275 86.8876 577.757 91.2208Z",
    fill: "#26ACB5"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2006_6961)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M494.606 51.7786C493.808 46.0844 498.23 41 503.98 41H569.765C575.515 41 579.936 46.0844 579.139 51.7786L571.015 109.753C570.36 114.427 566.362 117.905 561.642 117.905H512.103C507.383 117.905 503.384 114.427 502.729 109.753L494.606 51.7786Z",
    fill: "#9F7CAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M536.871 41H569.74C575.498 41 579.922 46.0982 579.111 51.7987L570.861 109.773C570.197 114.438 566.202 117.905 561.49 117.905H536.871V41Z",
    fill: "#5F2478"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M513.208 52.4626C513.208 50.6079 514.637 49.0643 516.487 48.9323C531.877 47.8348 541.883 47.8098 557.262 48.9274C559.109 49.0617 560.534 50.6042 560.534 52.4562V61.9992C560.534 64.072 558.761 65.7018 556.694 65.5487C542.062 64.465 532.278 64.3835 517.06 65.538C514.988 65.6951 513.208 64.0639 513.208 61.9864V52.4626Z",
    fill: "#EFE9F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2006_6961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 513,
    y: 48,
    width: 48,
    height: 18
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M513.209 52.4621C513.209 50.6075 514.638 49.0638 516.488 48.9319C531.878 47.8344 541.884 47.8093 557.263 48.927C559.11 49.0612 560.535 50.6037 560.535 52.4558V61.9987C560.535 64.0715 558.762 65.7013 556.695 65.5482C542.063 64.4645 532.279 64.383 517.061 65.5375C514.989 65.6946 513.209 64.0634 513.209 61.986V52.4621Z",
    fill: "#EFE9F1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2006_6961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.465 58.7474L540.026 67.621H534.903L537.465 58.7474Z",
    fill: "#5F2478"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.759,
    y: 46.9176,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.124,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.899,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.674,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.449,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.814,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.589,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.364,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.14,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.507,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.282,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.057,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.83,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.197,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543.972,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.747,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.521,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.886,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.662,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.438,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.211,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M485.109 110.856C485.109 110.856 485.298 100.996 498.172 99.0245L485.109 110.856Z",
    fill: "#26ACB5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M590.541 111.931C590.541 111.931 587.764 102.469 574.825 103.955L590.541 111.931Z",
    fill: "#26ACB5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M485.558 110.342C485.558 110.342 481.868 101.196 492.939 94.3369L485.558 110.342Z",
    fill: "#26ACB5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M589.973 111.552C589.973 111.552 591.126 101.757 578.64 98.0538L589.973 111.552Z",
    fill: "#26ACB5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M487.504 114.503C487.504 114.503 485.825 104.778 472.825 104.861L487.504 114.503Z",
    fill: "#26ACB5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M589.191 116.079C589.191 116.079 588.251 106.254 600.815 102.913L589.191 116.079Z",
    fill: "#26ACB5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M485.284 113.522C485.284 113.522 489.002 104.38 477.925 97.5754L485.284 113.522Z",
    fill: "#26ACB5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M591.075 114.549C591.075 114.549 585.082 106.708 593.977 97.2275L591.075 114.549Z",
    fill: "#26ACB5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_6961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 757,
    height: 106,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2006_6961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 757,
    height: 106,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2006_6961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 68,
    fill: "white",
    transform: "translate(467 41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2006_6961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.4286,
    height: 72.8571,
    fill: "white",
    transform: "translate(493.096 41)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.6540b2f6c63a0bedab75f5a7d1ee921c.svg";
export { ForwardRef as ReactComponent };